import debug from 'debug'

import PubSub from 'pubsub-js'

const log = debug('behaviour:button:summary-preview')

log('`behaviour` is awake')

export function handleHideClick () {
  log('handleHideClick')

  PubSub.publish('summary:preview', 'hide')
}

export function handleShowClick () {
  log('handleShowClick')

  PubSub.publish('summary:preview', 'show')
}
